import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const StyledButton = styled(Button)({
  background: '#4A445814',
  textTransform: 'inherit',
  borderRadius: '0rem',
  border: '0.0625rem solid #d6d6d6',
  backgroundColor: 'transparent',
  width: '9.375rem',
  color: '#1d1b20',
  fontWeight: '600',
  marginTop: '0.9375rem',
  padding: '0.5rem 0.625rem',
});

export default StyledButton;
